import { render, staticRenderFns } from "./AutocompleteOrganization.vue?vue&type=template&id=5c5b04e4&scoped=true&"
import script from "./AutocompleteOrganization.vue?vue&type=script&lang=js&"
export * from "./AutocompleteOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b04e4",
  null
  
)

export default component.exports